import { createModule } from '../createModule';

export const department = createModule('department');